module.exports = __webpack_public_path__ + "img/noconnected.f13fda19.svg";